import { render, staticRenderFns } from "./job-gofm.vue?vue&type=template&id=2419c91f&"
import script from "./job-gofm.vue?vue&type=script&lang=js&"
export * from "./job-gofm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports